import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { YTDPriceActivityModel } from './ytd-price-activity.model';

export class YTDPriceVolumeConfiguration extends ReportSectionConfigurationBase {
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_YTDPriceVolume];
  typeName = 'YTDPriceVolumeConfiguration';
  nodataLocalizationKeyName = 'bnyYTDPriceActivity';
  readonly reportSection = ReportSection.YtdPriceVolume;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  maxSize = 4;
  defaultSize = 2;
  minSize = 2;
  name = 'ytdPriceVolumeTitle';
  displayName = 'YTD Price & Trading Volume';
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface YTDPriceVolumeDetailsData {
  [ReportViewModelSection.BnyManagementReport_YTDPriceVolume]: YTDPriceActivityModel;
}
